"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./_internal/utils");
var take_1 = tslib_1.__importDefault(require("./Lazy/take"));
var pipe_1 = tslib_1.__importDefault(require("./pipe"));
var toArray_1 = tslib_1.__importDefault(require("./toArray"));
function head(iterable) {
    if ((0, utils_1.isIterable)(iterable)) {
        return (0, pipe_1.default)((0, take_1.default)(1, iterable), toArray_1.default, function (_a) {
            var _b = tslib_1.__read(_a, 1), a = _b[0];
            return a;
        });
    }
    if ((0, utils_1.isAsyncIterable)(iterable)) {
        return (0, pipe_1.default)((0, take_1.default)(1, iterable), toArray_1.default, function (_a) {
            var _b = tslib_1.__read(_a, 1), a = _b[0];
            return a;
        });
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = head;
//# sourceMappingURL=head.js.map